module.exports = __webpack_public_path__ + "static/media/logo.462d1337.svg";